import type {TraceData} from './copilot-chat-reducer'

const EMPTY_TRACE_MAP: ReadonlyMap<string, TraceData> = new Map<string, TraceData>()

export function filterTracesByThread(
  traces: ReadonlyMap<string, TraceData> | undefined,
  threadId: string | undefined | null,
): ReadonlyMap<string, TraceData> {
  if (!traces || traces.size === 0) {
    return EMPTY_TRACE_MAP
  }

  const threadTraces = new Map<string, TraceData>()
  for (const [messageId, traceData] of traces) {
    if (!threadId || traceData.threadId === threadId) {
      threadTraces.set(messageId, traceData)
    }
  }
  return threadTraces.size > 0 ? threadTraces : EMPTY_TRACE_MAP
}

// Checks if there are any traces available for the specified thread
export function hasTracesForThread(
  traces: ReadonlyMap<string, TraceData> | undefined,
  threadId: string | undefined | null,
): boolean {
  return filterTracesByThread(traces, threadId).size > 0
}

export function hasTracesForSharedThread(traces?: ReadonlyMap<string, TraceData>): boolean {
  return !!traces && traces.size > 0
}

// Determines if traces should be available for the current context.
export function shouldHaveTracesAvailable(
  traces: ReadonlyMap<string, TraceData> | undefined,
  selectedThreadId: string | undefined | null,
  isSharedThread: boolean,
): boolean {
  if (!traces) {
    return false
  }

  // If no thread is selected and we're not on a shared thread, no traces should be available
  if (!selectedThreadId && !isSharedThread) {
    return false
  }

  // Check for regular traces for current thread
  const hasRegularTraces = hasTracesForThread(traces, selectedThreadId)

  // For shared threads, also check for shared traces
  if (isSharedThread) {
    const hasSharedTraces = hasTracesForSharedThread(traces)
    return hasRegularTraces || hasSharedTraces
  }

  return hasRegularTraces
}
